import React, { useState, useEffect, useRef, useCallback } from 'react';
import { useInterval } from 'usehooks-ts';
import { Spinner } from 'react-bootstrap';

import { useHttpUtils, correlationId } from '../../Utilities/useHttpUtils';
import useAlert from '../../Alerts/useAlert';
import { useSiteCode } from '../../Utilities/useSiteCode';
import LotListTable from './LotListTable';

function LotListTableSelector({ tableFilters, tableName, loadingFilters }) {

    const siteCode = useSiteCode();

    const { setAlert } = useAlert()
    const { fetchDataAuthenticated } = useHttpUtils();

    const [loading, setLoading] = useState(true);
    const [lots, setLots] = useState([]);
    const autoResetPage = useRef(true);

    const getLots = useCallback(async () => {
        let params = new URLSearchParams();

        if (tableFilters.status) {
            params.append("status", tableFilters.status);
        }

        if (tableFilters.dateFilter?.from) {
            params.append("dateFrom", tableFilters.dateFilter.from);
        }

        if (tableFilters.dateFilter?.to) {
            params.append("dateTo", tableFilters.dateFilter.to);
        }

        if (tableFilters.includeGraded) {
            params.append("includeGraded", tableFilters.includeGraded);
        }

        if (tableFilters.selectedBusinessUnits?.length > 0) {
            params.append("businessUnits", tableFilters.selectedBusinessUnits.map(bu=>bu.code).join(","));
        }

        if (tableFilters.selectedLines?.length > 0) {
            params.append("lines", tableFilters.selectedLines.map(l => l.productionLine).join(","));
        }

        await fetchDataAuthenticated("api/v1/lots?" + params.toString())
            .then(async response => {
                if (response.ok) {
                    return response.json();
                }

                throw new Error(`Failed to get lots [${correlationId}]`);
            })
            .then(data => {
                // disable auto page reset on the table while getting the data
                autoResetPage.current = false;
                setLots(data);
            })
            .catch(error => {
                setAlert("danger", "Error", error.message);
            })
            .finally(() => {
                setLoading(false);
            });
    }, [fetchDataAuthenticated, setAlert, tableFilters.dateFilter.from, tableFilters.dateFilter.to, tableFilters.includeGraded, tableFilters.selectedBusinessUnits, tableFilters.selectedLines, tableFilters.status]);

    // update table at interval
    useInterval(async () => {
        if (!loadingFilters) {
            getLots();
        }
    }, 30000);

    useEffect(() => {
        if (!loadingFilters) {
            setLoading(true);
            getLots();
        }
    }, [loadingFilters, getLots]);

    if (loading || loadingFilters) {
        return (
            <div className="d-flex justify-content-center">
                <Spinner animation="border" />
            </div>
        );
    }

    switch (siteCode) {
        default:
            return <LotListTable lots={lots} tableFilters={tableFilters} tableName={tableName} autoResetPage={autoResetPage} refreshLotList={getLots} />
    }
}

export default LotListTableSelector;